import scroll from 'utilities/scroll';

export const useResidentValidation = ({ setShowResidentAdvise }) => {
    const handleValidateResident = isResident => {
        setShowResidentAdvise(!isResident);

        if (!isResident) {
            const residentDisclosureElement = document.getElementById('countryRestriction');
            scroll.transition(residentDisclosureElement, 'top');
        }
    };

    return { handleValidateResident };
};
